import axios from '../axios'
/**
 * 查询培训信息
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const examinPointList = data => {
  return axios({
    url: 'coachExamin/website/examinPoint/list',
    method: 'POST',
    data,
    headers: {
      isToken: false
    }
  })
}
/**
 * 查询详情
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const examinPointDetail = data => {
  return axios({
    url: 'coachExamin/website/examinPoint/detail/' + data.id,
    method: 'GET',
    headers: {
      isToken: false
    }
  })
}

/**
 * 查询考试项目
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const examinProjectList = data => {
  return axios({
    url: 'coachExamin/website/examinProject/list/' + data.pointId,
    method: 'GET',
    headers: {
      isToken: false
    }
  })
}

/**
 * 查询报名信息
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const examinJoinList = data => {
  return axios({
    url: 'coachExamin/examinJoin/list/' + data.pointId,
    method: 'GET'
  })
}

/**
 * 报名提交
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const examinJoinAdd = data => {
  return axios({
    url: 'coachExamin/examinJoin/add',
    method: 'POST',
    data
  })
}

/**
 * 删除报名信息
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const examinJoinDel = data => {
  return axios({
    url: 'coachExamin/examinJoin/del/' + data.id,
    method: 'DELETE'
  })
}

/**
 * 查询日程安排
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const examinScheduleList = data => {
  return axios({
    url: 'coachExamin/website/examinSchedule/list/' + data.pointId,
    method: 'GET',
    headers: {
      isToken: false
    }
  })
}

/**
 * 查询培训讲师
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const examinLecturerList = data => {
  return axios({
    url: 'coachExamin/website/examinLecturer/list/' + data.pointId,
    method: 'GET',
    headers: {
      isToken: false
    }
  })
}

/**
 * 查询通知公告
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const examinNoticeList = data => {
  return axios({
    url: 'coachExamin/website/examinNotice/list/' + data.pointId,
    method: 'GET',
    headers: {
      isToken: false
    }
  })
}

/**
 * 生成支付订单
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const examinCreateOrder = data => {
  return axios({
    url: 'coachExamin/examinJoinOrder/createOrder/' + data.joinId,
    method: 'GET'
  })
}

/**
 * 查询订单支付状态 {orderNumber}/{orderType}
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const queryOrderStatus = data => {
  return axios({
    url: '/coachExamin/examinJoinOrder/queryOrderStatus/' + data.orderNumber + '/' + data.orderType,
    method: 'get'
  })
}

/**
 * 获取考试项目
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const checkList = data => {
  return axios({
    url: 'coachExamin/examinQuestionNum/checkList/' + data.joinId + '/' + data.pointId + '/' + data.projectId,
    method: 'GET'
  })
}

/**
 * 考试提交
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const examinAnswer = data => {
  return axios({
    url: 'coachExamin/examinQuestionAnswer/answer',
    method: 'POST',
    data
  })
}

/**
 * 查询答题
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const answerOne = data => {
  return axios({
    url: 'coachExamin/examinQuestionAnswer/getOne/' + data.pointId + '/' + data.joinId + '/' + data.questionId + '/' + data.projectId,
    method: 'GET'
  })
}

/**
 * 查询答题分数
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const answerScore = data => {
  return axios({
    url: 'coachExamin/examinQuestionAnswer/score/' + data.pointId + '/' + data.joinId + '/' + data.projectId,
    method: 'GET'
  })
}



// WEBPACK FOOTER //
// ./src/comm/http/modules/examin.js